import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import checkDispatcher from 'helpers/Dispatcher';

const Disclaimer = ({ className, small, spaced }) => {
    const classes = classnames(className, {
        'check-list': true,
    });
    const itemClasses = classnames({
        'check-list__item': true,
        'check-list__item--small': small,
        'check-list__item--spaced': spaced,
    });
    return (
        <ul className={classes}>
            <li className={itemClasses}>
                <span>Gratuit et sans engagement</span>
            </li>
            <li className={itemClasses}>
                <span>
                    En cliquant sur « Voir mon estimation », vous acceptez nos{' '}
                    <a target="_blank" href="/terms">
                        conditions générales d&apos;utilisation
                    </a>{' '}
                    et notre{' '}
                    <a target="_blank" href="/terms#privacy">
                        politique de confidentialité
                    </a>
                    .
                </span>
            </li>
            <li className={itemClasses}>
                {checkDispatcher('estima_update_legal_notice_pinpo') ? (
                    <span>
                        Digital Classifieds France procède au traitement des données nécessaires à
                        votre inscription et l&apos;utilisation de ses services - pour ce faire,
                        Digital Classifieds France est susceptible de vous contacter par téléphone,
                        SMS ou autres moyens de communication; ces données sont uniquement destinées
                        à Digital Classifieds France.
                    </span>
                ) : (
                    <span>
                        Digital Classifieds France procède au traitement des données nécessaires à
                        votre inscription et l&apos;utilisation de ses services; ces données sont
                        uniquement destinées à Digital Classifieds France.
                    </span>
                )}
            </li>
            <li className={itemClasses}>
                <span>
                    Vous disposez d&apos;un droit d&apos;accès, de rectification, d&apos;effacement
                    et d&apos;opposition, pour les informations vous concernant. Pour exercer vos
                    droits,{' '}
                    <a target="_blank" href="/support/contact">
                        contactez-nous
                    </a>
                    .
                </span>
            </li>

            <li className={itemClasses}>
                <span>
                    MeilleursAgents propose aux particuliers un service d&apos;aide à un projet
                    immobilier, dont la réalisation de l&apos;estimation en ligne peut constituer le
                    préalable avant l&apos;estimation par des professionnels de l&apos;immobilier.
                </span>
            </li>
        </ul>
    );
};

Disclaimer.displayName = 'Disclaimer';

Disclaimer.propTypes = {
    className: PropTypes.string,
    small: PropTypes.bool,
    spaced: PropTypes.bool,
};

Disclaimer.defaultProps = {
    small: false,
    spaced: false,
};

/**
 * Disclaimer Functional Component.
 */
export default Disclaimer;
